import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

const initialState = {
    footerData: {},
    error: null,
    showSMSMessage: false,
}

export const footerSlice = createSlice({
    name: "footer",
    initialState: initialState,
    reducers: {
        setShowSMSMessage: (state, action) => {
            state.showSMSMessage = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchData.fulfilled, (state, action) => {
            state.error = null
            state.footerData = parseFooterData(action.payload)
        }),
            builder.addCase(fetchData.pending, (state) => {
                state.error = null
                state.footerData = {}
            }),
            builder.addCase(fetchData.rejected, (state, action) => {
                state.error = action.payload
            })
    },
})

const parseFooterData = (data) => {
    if (!data) return null
    return {
        headers: data.headers,
        platformStatsOrder: data.platform_stats_order,
        statsData: data.stats_data,
        smsAppLink: data.sms_app_link,
        domainsSectionsOrder: data.domains_sections_order,
        sectionsLinks: data.sections_links,
        connectData: data.connect_data,
        downloadApp: data.download_app,
        trustSection: data.trust_section,
        legitScript: data.legit_script,
        signupData: data.signup_data,
        knowMoreSection: data.know_more_section,
        copyrightText: data.copyright_text,
    }
}

export const fetchData = createAsyncThunk("footer/fetchData", async (_arg, { extra }) => {
    const { api } = extra
    const res = await api.get("/api/v4/footer-data")
    return res.data
})

export const sendDownloadLink = createAsyncThunk(
    "footer/sendDownloadLink",
    async (payload, { extra, dispatch }) => {
        const { api } = extra
        const res = await api.post("/webservices/app-install-link", payload)
        dispatch(setShowSMSMessage(true))
        setTimeout(() => {
            dispatch(setShowSMSMessage(false))
        }, 3000)
        return res
    }
)

//reducer
export const footerReducer = footerSlice.reducer
export const { setShowSMSMessage } = footerSlice.actions
